import PropTypes from 'prop-types'

const NavigationMenuPropTypes = {
  pages: PropTypes.array,
  rootRoute: PropTypes.string
}

export default NavigationMenuPropTypes
